import { DialogContent, DialogTitle } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { UseEntityStore } from "../../common/entityStore";
import { CustomerDto } from "./types";
import { CustomerAddressList } from "./CustomerAddressList";
import { customerDialogTitle, useCustomerBasicInfo } from "./common";

export function CustomerAddressListDialog(props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
    disabled: boolean;
}) {
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    return <>
        <DialogTitle>{customerDialogTitle("Customer addresses", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <CustomerAddressList useCustomerStore={props.useCustomerStore} disabled={props.disabled} />
        </DialogContent>
    </>;
}
